import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AiModels = lazy(() => import('./AiModels').then((module) => ({ default: module.AiModels })))

class AiModelsWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['self-service-flag']
	}

	override render() {
		const selfServiceFeatureFlagEnabled = this.prop('self-service-flag') === 'true'

		return <AiModels isDeleteUserProfilesEnabled={selfServiceFeatureFlagEnabled} />
	}
}

customElements.define('ai-models-component', AiModelsWebComponent)
